import { cn } from "@/lib/utils";
import { Loader2, SaveAll } from "lucide-react";
import { useEffect, useState } from "react";

/**
 * This component is used to indicate that the user is saving their work
 * It listens to the saving-started and saving-finished events from editor persistence hook
 * and displays a pulse animation when the saving is in progress
 */
export default function SavingIndicator() {
	const [isSaving, setIsSaving] = useState(false);

	const handleSavingStarted = () => {
		setIsSaving(true);
	};

	const handleSavingFinished = () => {
		setIsSaving(false);
	};

	// We are listening to the saving-started and saving-finished events from the parent component
	useEffect(() => {
		document.addEventListener("saving-started", handleSavingStarted);
		document.addEventListener("saving-finished", handleSavingFinished);

		return () => {
			document.removeEventListener("saving-started", handleSavingStarted);
			document.removeEventListener("saving-finished", handleSavingFinished);
		};
	}, []);

	return (
		<div className="relative flex flex-row items-center justify-left gap-2 w-[160px]">
			<div
				className={cn(
					"absolute flex flex-row items-center gap-2 transition-opacity duration-300",
					!isSaving ? "opacity-100" : "opacity-0",
				)}
			>
				<SaveAll className="h-3 w-3 text-gray-500" />
				<span className="text-xs text-gray-500">Gespeichert</span>
			</div>
			<div
				className={cn(
					"absolute flex flex-row items-center gap-2 transition-opacity duration-300",
					isSaving ? "opacity-100" : "opacity-0",
				)}
			>
				<Loader2 className="h-3 w-3 animate-spin text-gray-500" />
				<span className="text-xs text-gray-500">Speichern...</span>
			</div>
		</div>
	);
}
